import { reactive } from 'minimal-view'
import { audio } from './audio'

export type Anim = typeof Anim.State

export const Anim = reactive('anim',
  class props {
  },
  class local {
    rulerNow = 0
    entities: ((quick?: boolean) => void)[] = []
    running = false
  },
  function actions({ $, fn, fns }) {
    let animFrame: any
    // let actualNow: number
    // let dt = 0
    // let prevMs = 0
    // let prevNow = 0

    return fns(new class actions {
      tick = (ms: number) => {
        // dt = ms - prevMs
        // prevMs = ms
        // actualNow = (audio.$.graph?.clock?.internalTime ?? 0)

        // if (prevNow !== actualNow) {
        //   $.rulerNow += (dt / 1000) * (audio.$.graph?.clock?.coeff ?? 0)
        //   if (Math.abs(actualNow - $.rulerNow) > .5) {
        //     $.rulerNow = actualNow
        //   }
        // }

        this.draw()

        animFrame = requestAnimationFrame(this.tick)
      }

      start = () => {
        if ($.running) return

        $.running = true
        // prevNow = $.rulerNow = (audio.$.graph?.clock?.internalTime ?? 0)
        cancelAnimationFrame(animFrame)
        // this.tick(prevMs = performance.now())
        this.tick(performance.now())
      }

      stop = () => {
        $.running = false
        cancelAnimationFrame(animFrame)

        // const waitForStop = () => {
        //   // actualNow = (audio.$.graph?.clock?.internalTime ?? 0)
        //   // $.rulerNow = actualNow
        //   // if (actualNow === prevNow) {
        //   //   this.draw()
        //   //   return
        //   // }
        //   animPlaying = requestAnimationFrame(waitForStop)
        // }

        // waitForStop()
      }

      draw = fn(({ entities }) => () => {
        for (let i = 0; i < entities.length; i++) {
          entities[i](true)
        }
      })
    })
  },
  function effects({ $, fx, deps }) {
    fx(() => audio.fx(({ isPlaying, rmsSum }) => {
      if (isPlaying || rmsSum > 0.05) {
        if (!$.running) $.start()
      }
      else {
        if ($.running) requestAnimationFrame($.stop)
      }
    }))
  }
)

export const anim = Anim({})
